'use strict'

exports.url = process.env.VUE_APP_API;
